import { useCallback, useEffect, useState } from "react";
import { api } from "@/lib/api";
import { PageHeader } from "@/components/common/Primitives";
import { Tabs } from "@/components/common/Tabs";
import { PhotoGrid } from "@/components/photos/Photos";

export default function PhotosPage() {
  const [status, setStatus] = useState("pending");
  const [photos, setPhotos] = useState(null);
  const load = useCallback(() => api.get("/photos", { params: status === "all" ? {} : { review_status: status } }).then((r) => setPhotos(r.data)), [status]);
  useEffect(() => { load(); }, [load]);
  return (
    <div>
      <PageHeader title="Photo review" subtitle="Approve, reject or convert captured photos into issues" testId="photos-header" />
      <Tabs id="photos" value={status} onChange={setStatus} tabs={[["pending", "Pending"], ["approved", "Approved"], ["rejected", "Rejected"], ["all", "All"]]} />
      <PhotoGrid photos={photos} reload={load} reviewMode />
    </div>
  );
}
